const tg = window.Telegram.WebApp;

export function useTelegram() {

    const onClose = () => {
        tg.close()
    }

    const onToggleButton = () => {
        if(tg.MainButton.isVisible) {
            tg.MainButton.hide();
        } else {
            tg.MainButton.show();
        }
    }

    return {
        onClose,
        onToggleButton,
        tg,
        tguser: tg.initDataUnsafe?.user,
        queryId: tg.initDataUnsafe?.query_id,
        colorScheme: tg.colorScheme,
        startParam: tg.initDataUnsafe?.start_param,
        shareMessage: tg.shareMessage
    }
}